export const PlanProcedureRow = {
  flow: 'x',
  align: 'center space-between',
  padding: 'Y Z',
  borderBottom: '1px solid inkBorder',
  ':last-child': { borderBottom: 'none' },
  ProcName: { text: (el, s) => s.procedure || 'Procedure', fontSize: 'Z', color: 'inkText', flex: '1' },
  Cost: { show: (el, s) => !s.root.chairSideMode, text: (el, s) => s.cost || '$0', fontSize: 'Z', fontWeight: '600', color: 'teal' },
  Notes: {
    if: (el, s) => !!s.notes,
    text: (el, s) => s.notes || '',
    fontSize: 'Y',
    color: 'inkMuted',
    marginLeft: 'Y'
  }
}

export const PlanColumn = {
  flow: 'y',
  flex: '1',
  gap: 'Y',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  PlanLabel: {
    text: (el, s) => s.planLabel || 'Plan',
    fontSize: 'A',
    fontWeight: '700',
    color: 'inkText',
    paddingBottom: 'Y',
    borderBottom: '2px solid teal'
  },
  TotalCost: { show: (el, s) => !s.root.chairSideMode, text: (el, s) => 'Total: ' + (s.totalCost || '$0'), fontSize: 'Z', fontWeight: '700', color: 'teal' },
  Procedures: {
    flow: 'y',
    childExtends: 'PlanProcedureRow'
  }
}

export const AlternativePlanTab = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  Header: {
    text: '{{ treatmentPlanComparison | polyglot }}',
    fontSize: 'B',
    fontWeight: '700',
    color: 'inkText',
    marginBottom: 'Y'
  },
  Plans: {
    flow: 'x',
    gap: 'Z',
    '@mobileL': { flow: 'y' },
    PlanA: { extends: 'PlanColumn', state: { planLabel: 'Plan A (Recommended)' } },
    PlanB: { extends: 'PlanColumn', state: { planLabel: 'Plan B (Alternative)' } }
  },
  DifferenceNote: {
    text: (el, s) => s.differenceNote || 'Highlighted differences show cost and procedure variations between plans.',
    fontSize: 'Z',
    color: 'inkMuted',
    padding: 'Y Z',
    background: 'amber.15',
    round: 'Z',
    marginTop: 'Y'
  }
}
